import script from "./AddCapa.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCapa.vue?vue&type=script&setup=true&lang=js"

import "./AddCapa.vue?vue&type=style&index=0&id=5bf3e7f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf3e7f6"]])

export default __exports__